import React, { useEffect, useCallback } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { getConnectionsClients } from '~data/selectors/oauth';
import { connectionsLoad, clientRevoke } from '~data/actions/oauth';

import {
  Title, Separator, Wrap, Button,
  Item, ItemIcon, ItemTitle, ItemInfo, ItemActions,
} from '~ui';
import { Icon } from '~ui'
import { Confirm } from '~co/overlay/dialog';

export default function SettingsIntegrationsConnections() {
  const clients = useSelector(getConnectionsClients);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(connectionsLoad());
  }, [dispatch]);

  const onRevokeClick = useCallback(
    async (e) => {
      e.preventDefault();
      const _id = e.currentTarget.getAttribute('data-id');

      if (await Confirm(t.s('areYouSure'), { ok: t.s('removeApp') }))
        dispatch(clientRevoke(_id));
    },
    [dispatch],
  );

  if (!clients.length) return null;

  return (
    <>
      <Title>{t.s('connectedApps')}</Title>

      <Wrap className='col-span-full'>
        {clients.map(({ _id, name, description, site, icon }) => (
          <Item key={_id} as='a' href={site} target='_blank'>
            {icon && (
              <ItemIcon>
                <img src={icon} />
              </ItemIcon>
            )}
            <ItemTitle>{name}</ItemTitle>
            <ItemInfo>{description}</ItemInfo>
            <ItemActions>
              <Button
                variant='ghost'
                size='icon'
                data-id={_id}
                title={t.s('removeApp')}
                onClick={onRevokeClick}
              >
                <Icon name='close' />
              </Button>
            </ItemActions>
          </Item>
        ))}
      </Wrap>

      <Separator />
    </>
  );
}
